import { EnumCompanyStatus, EnumUserRole } from "@/shared/api-contract/api-contract";
import { currentUserModel } from "@/shared/state/current-user.model";
import { currentCompanyModel } from "@/shared/state/current-company.model";
import { computed } from "vue";
import { sessionModel } from "@/shared/state/session.model";

export class DashboardModel {
    readonly isApprovedCompany = computed(() => {
        return (
            !!currentCompanyModel?.companyDto?.value?.status?.id &&
            currentCompanyModel.companyDto.value?.status.id === EnumCompanyStatus.APPROVED
        );
    });

    readonly canShowOrdersPage = computed(() => {
        if (
            !!sessionModel.JWTUserDto.value?.id_role &&
            sessionModel.JWTUserDto.value?.id_role >= EnumUserRole.VIEWER
        ) {
            return this.isApprovedCompany.value;
        }
        return false;
    });

    readonly canOnlyShowPageToAdmin = computed(() => {
        if (
            currentUserModel.userDto.value !== undefined &&
            currentUserModel.userDto.value?.role.id === EnumUserRole.ADMINISTRATOR
        ) {
            return this.isApprovedCompany.value;
        }
        return false;
    });

    readonly canShowFavoritesPage = computed(() => {
        if (
            currentUserModel.userDto.value !== undefined &&
            currentUserModel.userDto.value?.role.id >= EnumUserRole.VIEWER
        ) {
            return this.isApprovedCompany.value;
        }
        return false;
    });

    readonly canShowOrderHistoryPage = computed(() => {
        if (
            !!currentUserModel?.userDto?.value?.role?.id &&
            currentUserModel.userDto.value?.role.id >= EnumUserRole.VIEWER
        ) {
            return this.isApprovedCompany.value;
        }
        return false;
    });
}

export const dashboardModel = new DashboardModel();
